import jwt_decode from "jwt-decode";
import { getSession } from "./Session";

const getIsImpersonatedFromToken = () => {
  try {
    const session = getSession();
    return !!jwt_decode(session.getAccessToken())?.impersonator;
  } catch {
    return false;
  }
};

export default getIsImpersonatedFromToken;
